module.exports = __webpack_public_path__ + "img/home.f8c1503f.png";